import React, { useState, useEffect, useRef } from "react";
// import "../../Assests/Scss/ViewAnswerSheet.scss";
// import axios from "axios";
import CommentPopup from "../../Student/PerformanceReport/CommentPopup";
// Below is for import the icons
import { TfiNotepad } from "react-icons/tfi";
import { GrScorecard } from "react-icons/gr";
import { GoQuestion } from "react-icons/go";
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import { FaGripLinesVertical } from "react-icons/fa";
// Below is for import the components
// import CopyRight from "../../Reusablecomponents/Copyright";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import Loading from "../../Student/Reusablecomponents/Loading";
import { AssessmentName, CAssessmentName } from "../../Student/Reusablecomponents/RegularFunctions";
import ScenarioQuestionformat from "../../Student/Reusablecomponents/ScenarioQuestionformat";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { FaRegIdBadge } from "react-icons/fa";
import { MdOutlineGrade } from "react-icons/md";
import { useSelector } from "react-redux";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import NSFLOgo from "../../Student/Assests/Images/NSFLOgo.jpg";
import NCLLOgo from "../../Student/Assests/Images/NCLogo.png";
import DropDown from "../../Student/Reusablecomponents/DropDown";
import axiosInstance from "../../ReusableComponents/Axios";

const HQViewAnswerSheet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const AnswerSheet = useRef();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const TeacherStudent = JSON.parse(localStorage.getItem("T2S"));
  const HQNDetails = JSON.parse(localStorage.getItem("HQNVLO"));
  const ASSUbjects = TeacherStudent?.Subjects ? TeacherStudent?.Subjects.split(",").map(s => s.trim()) : [];
  const [ViewSheet, SetViewSheet] = useState();
  const [SubjectwisePerformance, SetSubjectwisePerformance] = useState();

  const [OpenComment, SetOpenComment] = useState(false);
  const [StoreComment, SetStoreComment] = useState();

  const [Subname, SetSubname] = useState(
    localStorage.getItem("subName") || location.state?.SSubject || ASSUbjects[0]
  );
  const [Index, SetIndex] = useState();
  const [Load, SetLoad] = useState(false);

  const fetchSubjectwisePerformance = async (sub) => {
    try {
      SetSubjectwisePerformance();
      const res = await axiosInstance.get(`/StudentResults/GetStudentSubjectwisePerformance?ContestCreationId=${TeacherStudent?.CCID
        }&UserId=${TeacherStudent?.Studentid || items?.userId
        }&AssessmentType=${TeacherStudent?.TesType}`);
      if (res.data[0].isAttended) {
        SetIndex(res.data.findIndex((obj) => obj.subjectName === sub));
        SetSubjectwisePerformance(res.data);
      } else {
        SetSubjectwisePerformance(location.state?.ATType === "single" ? `The assessment is not yet scheduled for the subject - ${sub}` : process.env.REACT_APP_NODATAFOUND);
      }
    }
    catch (err) { console.log(err) }
  };
  const GetStudentAnswersheet = async (sub) => {
    try {
      SetViewSheet();
      SetLoad((prev) => !prev);
      const res = await axiosInstance.get(`/StudentResults/GetStudentAnswerSheet?ContestCreationId=${TeacherStudent?.CCID
        }&UserId=${TeacherStudent?.Studentid || items.userId}&SubjectName=${localStorage.getItem("subName") || sub
        }&AssessmentType=${TeacherStudent?.TesType}&LanguageId=${items?.mediumId || TeacherStudent?.mediumOfInstruction
        }`);

      SetViewSheet(res.data);
      localStorage.removeItem("subName");
      SetLoad((prev) => !prev);
    }
    catch (err) { console.log(err) }
  };

  useEffect(() => {
    localStorage.removeItem("QRating");
    GetStudentAnswersheet(localStorage.getItem("subName") || Subname || ASSUbjects[0]);
    fetchSubjectwisePerformance(localStorage.getItem("subName") || Subname || ASSUbjects[0]);
  }, []);
  const selectSubject = (e) => {
    GetStudentAnswersheet(e.target.value);
    localStorage.removeItem("subName");
    fetchSubjectwisePerformance(e.target.value);
    SetSubname(e.target.value);
  };

  const getLOData = (Subname, item) => {
    switch (Subname) {
      case "English":
        return item.englishLO;
      case "Mathematics":
        return item.loname;
      default:
        return item.scienceLO;
    }
  };

  const RateQuestion = (Qid, IsRating) => {
    if (IsRating === 0) {
      navigate(`/ViewAnswerSheetDetails/QuestionRating`, { state: { CCID: TeacherStudent?.CCID, TType: TeacherStudent?.TesType, QID: Qid } });
      localStorage.setItem("subName", Subname);
    }
  };

  const DownloadPDF = () => {
    const printContents = AnswerSheet.current.innerHTML;
    const printWindow = window.open("", "", "height=800,width=600");
    const filename = `${TeacherStudent?.AssessmentTypeName}_AnswerSheet_${Subname}_${TeacherStudent?.StudentRollno || items?.studentId}`;
    printWindow.document.write(`
    <html>
      <head>
        <style>
          /* General styles for print */
          @media print {
            body {
            font-size: 25px;
              position: relative;
            }

            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 100px;
              color: rgba(0, 0, 0, 0.1); /* low opacity */
              pointer-events: none;
              z-index: 9999;
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  gap: 30px;
  margin-bottom:50px;
}
 .PDFhide{
      display:none;}
.Icons-Div div {
  flex: 1;
  text-align: center;
  color:#000098;
}
.Icons-Div img {
              width: 30%;
              // height: 60px;
            }
            .Options  {
              display: flex !important; 
              align-items: center;
              gap: 8px;
              line-height: 1.4;
              page-break-inside: avoid;
              margin: 4px 0;
            }
.Each-Question{
 margin-bottom: 40px;
}
 .VScenario div b{
 color:#00A732;
 }
 .Question div b{
 color:#0071C1;
 }
            .Options > span  {
              display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
            }
.alignitems{
  display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
}
      
            /* Ensure watermark appears on every page */
            @page {
              size: auto;
              margin: 15mm;
            }
          }
        </style>
      </head>
      <body>
      <div class="Icons-Div">
       <img src="${NSFLOgo}" alt="NSF Logo"/>
       <div>
       <div><b>Assessment Date:</b> ${SubjectwisePerformance?.[Index]?.paperName}</div>
       <div><b>Subject:</b> ${SubjectwisePerformance?.[Index]?.subjectName}</div>
       </div>
       <img src="${NCLLOgo}" alt="NCL Logo" />
      </div>

      <div class="Icons-Div">
      <div> ${TeacherStudent?.StudentName || items?.fullName} | ${TeacherStudent?.StudentRollno || items?.studentId} | Grade${TeacherStudent?.Grade}</div>
      </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
      ${printContents}
      <script>
          window.onload = function() {
            setTimeout(() => {
              document.title = "${filename}";
              window.print();
              window.close();
            }, 400);
          }
        <\/script>
      </body>
    </html>
  `);
    printWindow.document.close();
  }
  return (
    <>
      <div
        className={`VASheet ${TeacherStudent ? " TeacherBgImage" : "Instructions-pages "
          }`}
      >
        <InternetChecking />
        {HQNDetails ?
          <b> <span >{HQNDetails?.Region?.RegionName ? <><span className="CPointer " onClick={() => navigate(-4)} style={{ color: "#696969" }}>{HQNDetails?.Region?.RegionName}</span> {""} &gt; {""} </> : ""}</span>
            <span className="CPointer " onClick={() => navigate(-3)} style={{ color: "#696969" }}>{HQNDetails?.State?.StateName || items?.societyName}</span> {""} &gt; {""}
            <span className="CPointer " onClick={() => navigate(-2)} style={{ color: "#696969" }}>{HQNDetails?.District?.DistrictName}</span>{""} &gt; {""}
            <span className="CPointer " style={{ color: "#696969" }} onClick={() => navigate(-1)}>{HQNDetails?.School?.SchoolName}</span>
          </b> : <div></div>}
        {TeacherStudent && (
          <div className="Vtitle">
            <h5>
              {CAssessmentName(TeacherStudent?.TesType)} -{" "}
              {SubjectwisePerformance?.[Index]?.paperName} -{" "}
              {SubjectwisePerformance?.[Index]?.subjectName}
            </h5>
          </div>
        )}
        <div className="dflex JSBetween alignitems">
          <div></div>
          <div
            className="dflex alignitems JSBetween VAMain-div "
          >
            <div className="dflex alignitems gap-3" >
              <DropDown className={location.state?.ATType === "single" ? "DisabledNCLDropdown" : "NCLDropdown"} options={ASSUbjects} selectoption={Subname} onChange={(e) => { selectSubject(e); }}
                disabled={location.state?.ATType === "single"} />

              <button className="Buttons p-2" onClick={DownloadPDF}>
                Download Answer Sheet
              </button>
            </div>
          </div>
        </div>
        {SubjectwisePerformance?.[0]?.isAttended ? (
          <>
            <div className=" Vtitle dflex alignitems">
              {!TeacherStudent && (
                <>
                  <h5>
                    {CAssessmentName(TeacherStudent?.TesType)} -{" "}
                    {location?.state?.ATType === "single" ? location?.state?.Date : SubjectwisePerformance?.[Index]?.paperName} -{" "}
                    {SubjectwisePerformance?.[Index]?.subjectName}
                  </h5>
                  <span>
                    <GoQuestion />{" "}
                    <WithTranslate
                      name="Answer sheet from my Last assessment.Questions"
                      Medium={TeacherStudent?.MediumName}
                    />
                    {SubjectwisePerformance?.[Index]?.noOfQuestions}
                  </span>
                  <span>
                    <TfiNotepad />{" "}
                    <WithTranslate
                      name="Answer sheet from my Last assessment.Max. Credits"
                      Medium={TeacherStudent?.MediumName}
                    />
                    {SubjectwisePerformance?.[Index]?.noOfQuestions * 2}
                  </span>
                  <span>
                    <GrScorecard />{" "}
                    <WithTranslate
                      name="Answer sheet from my Last assessment.Obtained Credits"
                      Medium={TeacherStudent?.MediumName}
                    />
                    {SubjectwisePerformance?.[Index]?.noOfQsCorrect * 2}
                  </span>
                </>
              )}
            </div>
            {TeacherStudent && SubjectwisePerformance?.[0]?.isAttended && (
              <div className=" Vtitle dflex alignitems">
                {/* TeacherStudentDetails */}
                <span>
                  <FaRegUser /> Student name : {TeacherStudent.StudentName}{" "}
                </span>
                <span>
                  {" "}
                  <FaRegIdBadge /> Student id : {
                    TeacherStudent.StudentRollno
                  }{" "}
                </span>
                <span>
                  {" "}
                  <MdOutlineGrade /> Grade : {TeacherStudent.Grade}{" "}
                </span>
                <span>
                  <GoQuestion />{" "}
                  <WithTranslate
                    name="Answer sheet from my Last assessment.Questions"
                    Medium={TeacherStudent?.MediumName}
                  />
                  {SubjectwisePerformance?.[Index]?.noOfQuestions}
                </span>
                <span>
                  <TfiNotepad />{" "}
                  <WithTranslate
                    name="Answer sheet from my Last assessment.Max. Credits"
                    Medium={TeacherStudent?.MediumName}
                  />
                  {SubjectwisePerformance?.[Index]?.noOfQuestions * 2}
                </span>
                <span>
                  <GrScorecard />{" "}
                  <WithTranslate
                    name="Answer sheet from my Last assessment.Obtained Credits"
                    Medium={TeacherStudent?.MediumName}
                  />
                  {SubjectwisePerformance?.[Index]?.noOfQsCorrect * 2}
                </span>
              </div>
            )}

            <div ref={AnswerSheet} className="Deatils-VASheet">
              {ViewSheet?.map((item, index) => (
                <div className="Each-Question dflex flexd-column">
                  {item.scenario && (
                    <div
                      className="VScenario dflex flexd-column"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <div>
                        {" "}
                        <b>Scenario :</b>{" "}
                        <ScenarioQuestionformat scenario={item.scenario} />
                      </div>
                      <div>
                        {" "}
                        <b>Scenario Source :</b> {item.scenarioSource} -{" "}
                        {item.scenarioBookSource}{" "}
                        {item.sComments && (
                          <>
                            <b>Comments:</b> {item.sComments}
                          </>
                        )}{" "}
                      </div>
                      {/* <div><b>Comments:</b> {item.sComments} </div> */}
                    </div>
                  )}
                  {/* <div><b>Rate this Question</b>Avg Rating: 1</div> */}

                  <div className="RQuestion dflex">
                    <div className="Question dflex flexd-column ">
                      <div>
                        <b>
                          Question {index + 1} - {item?.questionId} :
                        </b>
                        <span>
                          <ScenarioQuestionformat scenario={item.question} />
                        </span>
                      </div>
                      <div>
                        <b>Question Source :</b> {item.questionSource}
                      </div>
                    </div>

                    <div className="PDFhide">
                      <div>
                        {!TeacherStudent &&
                          (item.isRatingAvailable === 0 ? (
                            <b
                              onClick={() =>
                                RateQuestion(
                                  item.questionId,
                                  item.isRatingAvailable
                                )
                              }
                            >
                              <WithTranslate
                                name="Answer sheet from my Last assessment.Rate this Question"
                                Medium={TeacherStudent?.MediumName}
                              />
                            </b>
                          ) : (
                            <>
                              <b
                                onClick={() => {
                                  SetOpenComment(!OpenComment);
                                  SetStoreComment(item.qRatingComments);
                                }}
                              >
                                View Your Comments
                              </b>{" "}
                              | <b>You Rated this question already</b>
                            </>
                          ))}
                        <WithTranslate
                          name="Answer sheet from my Last assessment.Avg Rating"
                          Medium={TeacherStudent?.MediumName}
                        /> : {item.averageQRating}{" "}
                      </div>
                    </div>
                  </div>

                  {item?.questionType === "M" ? (
                    ["A", "B", "C", "D"].map((option, i) => (
                      <>{item[`option${option}`] &&
                        <div
                          key={i}
                          className="Options"
                          style={{
                            color:
                              option === item.answer
                                ? "green"
                                : option === item.userAnswer
                                  ? "red"
                                  : "black",
                          }}
                        >
                          {option})
                          <span>
                            <ScenarioQuestionformat
                              scenario={item[`option${option}`]}
                            />
                            {option === item.answer ? (
                              <TiTick fontSize={25} />
                            ) : option === item.userAnswer ? (
                              <ImCross />
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      }</>
                    ))
                  ) : (
                    <div className="dflex">
                      <b>Answer :</b>{" "}
                      <span style={{ color: "green" }}>
                        <ScenarioQuestionformat scenario={item?.answer} />
                      </span>
                    </div>
                  )}
                  <div className="">
                    {" "}
                    <b>Answer Explanation:</b>
                    <div className="AExplination">
                      <ScenarioQuestionformat
                        scenario={item.answerExplanation}
                      /></div>
                  </div>
                  <div className="alignitems">
                    {" "}
                    <b>Student Answer:</b>
                    {item.userAnswer ? item.userAnswer : "Not Attempted"}{" "}
                    <FaGripLinesVertical /> <b>Obtained Credit:</b>{" "}
                    {item.userAnswer ? item.stuCredits : "No Credit"}
                  </div>
                  {/* <div><b>Student Answer: </b>{item.userAnswer ? item.userAnswer : "Not Attempted"}</div> */}
                  {getLOData(Subname, item)
                    .split("$")
                    .map((strength, strengthindex) => (
                      <p key={strengthindex}>
                        {strength
                          .split(";")
                          .map((mstrength, mstrengthindex) => (
                            <p key={mstrengthindex}>
                              {mstrengthindex === 0 ? (
                                <span
                                  style={{
                                    //  color: (strengthindex%2 == 0) ? "green":"",
                                    fontWeight:
                                      strengthindex % 2 === 0 ? "bold" : "",
                                  }}
                                >
                                  {mstrength}
                                </span>
                              ) : (
                                mstrength
                              )}
                            </p>
                          ))}
                      </p>
                    ))}
                </div>
              ))}
            </div>
            {/* {items?.userTypeId === 4 &&
              <CopyRight />} */}
          </>
        ) : (
          <div className="ErrorMessage">{SubjectwisePerformance}</div>
        )}
      </div>
      {OpenComment && (
        <div className="SubmitModel">
          {" "}
          <CommentPopup
            Comment={StoreComment}
            CloseComment={SetOpenComment}
          />{" "}
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default HQViewAnswerSheet;
